import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import WorkIcon from "@mui/icons-material/Work";
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import LogoutIcon from "@mui/icons-material/Logout";
import { setUserData } from "../../redux/actions/user";
import { userSelector } from "../../redux/selectors";
import CreateJob from "../../components/CreateJob";
import TrackJobs from "../../components/TrackJobs";
import Credits from "../../components/Credits";
import Drafts from "../../components/Drafts";
import Header from "../../components/Header";
import { HOME } from "../../utils/routes";
import { useMediaQuery } from "../../utils/hooks";
import "./styles.scss";

const menu = [
  { icon: <WorkIcon />, label: "Create a Job" },
  { icon: <EditIcon />, label: "Drafts" },
  { icon: <FindInPageIcon />, label: "Track Jobs" },
  // { icon: <CrisisAlertIcon />, label: "Probability Score" },
  { icon: <LocalAtmIcon />, label: "Credits" },
  { icon: <LogoutIcon />, label: "Logout" },
];

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location: any = useLocation();

  const state: any = location.state;
  const trackJobs = useState(state && state.trackJobs ? true : false);

  const { user } = useSelector(userSelector);
  const matches = useMediaQuery("(min-width:1064px)");

  const [activeStep, setActiveStep] = useState(trackJobs ? 2 : 0);
  const [showDrawer, setShowDrawer] = useState(false);

  const MobileMenu = () => {
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setShowDrawer(true);
    };

    return (
      <div>
        <div onClick={handleClick}>
          <MenuIcon sx={{ cursor: "pointer" }} />
        </div>
        <Drawer
          anchor="right"
          open={showDrawer}
          onClose={() => {
            setShowDrawer(false);
          }}
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={() => {
              setShowDrawer(false);
            }}
            onKeyDown={() => {
              setShowDrawer(false);
            }}
          >
            <p className="menu-title">
              <b>{user.name}</b>
            </p>
            <p className="menu-email">
              <b>{user.email}</b>
            </p>
            {menu.map((item, index) => {
              return (
                <MenuItem
                  className={`dashboard-menu`}
                  onClick={() => {
                    handleMenuItemClick(index);
                  }}
                  key={item.label}
                >
                  <div>{item.icon}</div>
                  <div>{item.label}</div>
                </MenuItem>
              );
            })}
          </Box>
        </Drawer>
      </div>
    );
  };

  useEffect(() => {
    const employerData = JSON.parse(
      localStorage.getItem("employerData")
        ? localStorage.getItem("employerData") || "{}"
        : "{}"
    );

    dispatch(setUserData({ ...employerData }));

    if (!employerData.id || !employerData.name || !employerData.email) {
      navigate(HOME);
    }
  }, []);

  const handleMenuItemClick = (index: number) => {
    if (index === 4) {
      localStorage.setItem("employerData", JSON.stringify({}));
      navigate(HOME);
    }
    setActiveStep(index);
  };

  return (
    <>
      <Header>
        <p className="dashboard-employer-title">Employer Dashboard</p>
        {matches && <div></div>}
        {!matches && <MobileMenu />}
      </Header>
      <div className="dashboard-container">
        <div style={{ display: "flex" }}>
          {matches && (
            <div className="dashboard-tabs-container">
              {menu.map((item, index) => {
                return (
                  <div
                    className={`dashboard-menu ${
                      activeStep === index ? "dashboard-active-menu" : ""
                    }`}
                    onClick={() => {
                      handleMenuItemClick(index);
                    }}
                    key={item.label}
                  >
                    <div>{item.icon}</div>
                    <div>{item.label}</div>
                  </div>
                );
              })}
            </div>
          )}
          <div className="dashboard-content">
            <p className="dashboard-title">
              Welcome, <b>{user.name}</b>
            </p>
            {activeStep === 0 && (
              <div className="dashboard-create-job">
                <CreateJob />
              </div>
            )}
            {activeStep === 1 && <Drafts />}
            {activeStep === 2 && <TrackJobs fetch={trackJobs} />}

            {activeStep === 3 && <Credits />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
